import { render, staticRenderFns } from "./MatchExplorer.vue?vue&type=template&id=71b82c7f&scoped=true"
import script from "./MatchExplorer.vue?vue&type=script&lang=js"
export * from "./MatchExplorer.vue?vue&type=script&lang=js"
import style0 from "./MatchExplorer.vue?vue&type=style&index=0&id=71b82c7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b82c7f",
  null
  
)

export default component.exports